module.exports = __webpack_public_path__ + "img/mack_hollins.fdbcd69f.png";